import { MaintenanceForwardingCheckinEntryKlass } from "../../../../types/forwardings/checkinEntries/checkinEntry.type";

export const checkoutEntryOptions: {
  [K in MaintenanceForwardingCheckinEntryKlass]: {
    title: string;
  }
} = {
  [MaintenanceForwardingCheckinEntryKlass.TransportAutoEntry]: {
    title: 'Auto-locomoção',
  },
}
